<template>
  <button class="min-h-11 rounded-lg bg-blue-600 px-5 font-extrabold text-white transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200" :type="type">
    <slot />
  </button>
</template>

<script setup>
defineProps({
  type: { type: String, default: 'button' }
})
</script>
